import { Link, useLocation } from 'react-router';
import { useLocationStore } from '@/stores/useLocationStore';
import { useCartStore } from '@/stores/useCartStore';
import { getBookingDestination } from '@/lib/bookingDestination';
import { DatePicker } from '@/features/search/components/DatePicker';
import { LocationPicker } from '@/features/search/components/LocationPicker';

export function TripContext() {
    const { pathname } = useLocation();
    const { location } = useLocationStore();
    const { items } = useCartStore();
    const booking = getBookingDestination(items);
    const isCatalogue = /\/catalogue(\/|$)/.test(pathname);
    if (!isCatalogue && (!/\/product(\/|$)/.test(pathname) || !location)) return null;
    const mismatch = location && items.length > 0 && (!booking.isValid || booking.locationId !== location.id);
    return (
        <div className="sticky top-16 z-30 border-b border-border bg-background">
            <div className="container mx-auto flex flex-wrap items-center gap-x-6 gap-y-1 px-4 py-2">
                <div className="min-w-0 flex-1"><LocationPicker label="Collect & return" compact /></div>
                {isCatalogue && <div className="order-3 w-full border-t border-border pt-2 lg:order-none lg:w-64 lg:border-l lg:border-t-0 lg:pl-6 lg:pt-0"><DatePicker /></div>}
                {!isCatalogue && <Link to="/cart" className="inline-flex min-h-11 items-center text-sm font-semibold text-primary underline">Review booking</Link>}
                {mismatch && (
                    <p role="status" className="order-4 w-full pb-1 text-sm font-semibold text-foreground">
                        Browsing {location.name}. Your cart {booking.isValid ? `is still for ${booking.locationName || 'another destination'}` : 'needs a destination review'}. Changing the catalogue does not move your items.
                    </p>
                )}
            </div>
        </div>
    );
}
